import { render, staticRenderFns } from "./BankProductAdd.vue?vue&type=template&id=63ee4fd3"
import script from "./BankProductAdd.vue?vue&type=script&lang=js"
export * from "./BankProductAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports